<template lang="pug">
  div
    section.content-header
      h1 タグ管理

      ol.breadcrumb
        li
          router-link(:to="{name: 'admin'}")
            i.fa.fa-cog
            | システム管理
        li.active タグ管理

    section.content

      app-messages(:errorMessages="$store.state.base.flashMessages")
      app-messages(:errorMessages="errors", :successMessages="successes")

      mixin btnbar
        .bcard-btnbar.clearfix(class!=attributes.class)
          .pull-left
            app-list-sortable-nav(ref="sortableNav")
              template(slot-scope="{toggleSortMode}")
                router-link.btn.btn-default(:to="{name: 'admin'}" title="戻る"): i.fa.fa-reply
                |
                |
                router-link.btn.btn-primary(:to="{name: 'mgtag-add'}") タグの作成
                |
                |
                .btn-separator
                |
                |
                button.btn.btn-primary(@click="toggleSortMode") 表示順変更
                |
                |
                .btn-separator
                |
                |
                button.btn.btn-danger(@click="onClickDelButton") 削除
          .pull-right
            app-pagination(:is-loading="loadingPagination", :pagination="pagination", @change="getList")

      +btnbar

      //- ロード中
      .panel.panel-default
        loading(v-if="loading")

        //- データあり
        table.table.table-striped.table-bordered.bcard-table(v-else-if="list.length > 0", :class="{'sort-mode': $store.getState('isListSortMode')}")
          thead
            tr
              th.bcard-table-td-chk
                input(type="checkbox" @change="checkAll(list, $event.target.checked)", :disabled="$store.getState('isListSortMode')")
              th.bcard-table-td-color
              th タグ名
              th.bcard-table-th-count 登録数
          app-list-sortable(ref="sortableList", v-model="list", repo="mgtag")
            tr(
                v-for="(item, index) in list",
                :key="item.id",
                :class="{'selected': isChecked(item.id)}"
                )
              td.bcard-table-td-chk
                input(type="checkbox", :checked="isChecked(item.id)", @change="checkItem(item.id, $event.target.checked)", :disabled="$store.getState('isListSortMode')")
              td.bcard-table-td-color
                tag-color(:rgb="item.color_rgb")
              td.bcard-ui-userdata
                router-link(v-if="!$store.getState('isListSortMode')", :to="{name: 'mgtag-edit', params: {id: '' + item.id, item: item}}", :title="item.name") {{item.name}}
                router-link(v-else :to="{}", :title="item.name" event="") {{item.name}}
              td.bcard-table-td-count {{item.formatted_count_persons}}

        //- データなし
        .panel-body.text-center(v-else) タグ情報はありません。

      +btnbar.-bottom

    //------------------------------------------------------------
    //- modals
    //------------------------------------------------------------
    app-modal(type="danger" v-model="isModalConfOpen")
      template(slot="title") タグ情報の削除
      h4 選択したタグ情報を削除します。よろしいですか？
      p.bcard-comments.text-info ※ 名刺人物に登録されている場合、名刺人物からも削除されます。
      template(slot="footer", slot-scope="{close}")
        button.btn.btn-danger(type="button" @click="close(); delTags();") 削除
        button.btn.btn-default(type="button" @click="close") キャンセル

    app-modal(type="info" v-model="isModalNoitemOpen")
      h4 削除するタグを選択してください

</template>

<script>
import mixinList from '@/mixins/list'
import AppModal from '@/components/templates/AppModal'
import AppMessages from '@/components/molecules/AppMessages'
import AppPagination from '@/components/molecules/AppPagination'
import AppListSortable from '@/components/organisms/AppListSortable'
import AppListSortableNav from '@/components/organisms/AppListSortableNav'
import TagColor from '@/components/molecules/TagColor'
import Loading from '@/components/molecules/Loading'

export default {
  name: 'MgtagList',
  components: { AppModal, AppMessages, AppPagination, AppListSortable, AppListSortableNav, TagColor, Loading },
  mixins: [ mixinList ],
  data: function () {
    return {
      loadingPagination: true,
      loading: true,
      isModalConfOpen: false,
      isModalNoitemOpen: false
    }
  },
  created: function () {
    // サイドメニューから遷移
    if (this.$route.params.init) {
      this.getList({page: 1})
    }
    else {
      // 初期データ取得
      this.getList({page: this.pagination.current_page || 1})
    }
  },
  methods: {
    /**
     * 削除ボタンを押したときに呼ばれる
     * チェックされているものがあれば削除確認モーダルを開く
     * なにもチェックされていなければ手順お知らせモーダルを開く
     */
    onClickDelButton: function () {
      if (this.hasCheckedItems()) {
        this.isModalConfOpen = true
      }
      else {
        this.isModalNoitemOpen = true
      }
    },
    delTags: function () {
      // API実行
      this.sendBulkRequest('mgtag', 'bulkDelete', {
        params: {
          id: this.checkedIds
        }
      })
    },
    /**
     * 一覧取得処理
     * @param Object options
     *          page: ページ番号
     */
    getList: function (options) {
      const vm = this
      options = options || {}
      // API実行
      this.loading = true
      this.loadingPagination = !options.viaPagination
      this.sendListRequest({
        repo: 'mgtag',
        method: 'getList',
        params: {
          page: options.page || 1
        },
        finally: function () {
          vm.loading = false
          vm.loadingPagination = false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
/* タグカラーを表示する部分 */
.bcard-table-td-color {
  width:42px;

  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/admin/mgtag/List.vue